import { render, staticRenderFns } from "./OvOpenAmounts.vue?vue&type=template&id=9cc80c32&scoped=true&"
import script from "./OvOpenAmounts.vue?vue&type=script&lang=js&"
export * from "./OvOpenAmounts.vue?vue&type=script&lang=js&"
import style0 from "./OvOpenAmounts.vue?vue&type=style&index=0&id=9cc80c32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc80c32",
  null
  
)

export default component.exports